exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blog__title[data-v-099fe2b0]{display:inline-block;vertical-align:middle;font-family:Montserrat,sans-serif;font-size:30px;margin-top:0;margin-bottom:10px;font-weight:800;text-transform:uppercase}@media screen and (max-width:64em){.blog__title[data-v-099fe2b0]{width:100%}}@media only screen and (min-width:64.063em){.blog__title[data-v-099fe2b0]{width:35%}}.blog-list[data-v-099fe2b0]{font-family:Montserrat,sans-serif}.blog-list_head[data-v-099fe2b0]{display:block;width:100%}.blog-list_empty-articles[data-v-099fe2b0]{height:50vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-099fe2b0","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/page/blog/list/List.vue
// module id = a0e8c0189da3e6ef0fc2
// module chunks = 12